import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const CLICK_TO_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.ClickToPay,
    name: 'clicktopay',
    tokenRequired: true
};
